export default {
  block: {
    producerSchedule: {
      title: "BP节点交替时间表"
    },
    dpos_lib_num: "当时最新不可逆区块号",
    scheduleVersion: "时间表版本",
    transactionCount: "交易量",
    irreversible: "不可逆",
    stale: "过时",
    reversible: "可逆",
    title: "区块",
    newBlock: "{{count}} 个新区块",
    newBlock_plural: "{{count}} 个新区块",
    list: {
      title: "区块",
      empty: "无区块",
      loading: "读取区块中……",
      header: {
        timestamp: "时间戳",
        block_num: "区块号",
        id: "区块ID",
        age: "寿命",
        producer: "出块节点",
        transactionCount: "交易量",
        productionTimeElapsed: "出块时间"
      }
    }
  }
}
